import { List } from "../common/list";

export const ProofImpact = () => {
    const features = [
        '40% Faster Hires',
        '60% Lower Cost-Per-Hire',
        'DEI Uplift',
        'Higher Candidate Satisfaction',
    ];
    return (
        <div className='relative'>
            <div className="max-w-7xl mx-auto text-white py-16 px-6 overflow-hidden py-[100px] sm:py-[250px]">
                <div className="relative z-10 flex flex-col md:flex-row justify-between items-center gap-10">
                <div className="absolute h-[500px] w-[500px] -left-20 -top-32 z-20">
                    <img src="/circle2.png" alt="" />
                </div>

                    <div className="">
                        <h2 className="text-3xl md:text-6xl font-medium font-oxanium mb-10">
                            Proof of Impact
                        </h2>
                        <List features={features} classes={`list-disc list-inside marker:text-[#04D1D6] space-y-10 font-lato font-light text-xl lg:text-2xl`} />
                    </div>
                    <div className="w-full md:w-[425px] h-auto rounded-xl overflow-hidden">
                        <img src="/impact.png" alt="AI AURA" />
                    </div>
                </div>
            </div>
        </div>
    )
}
